export type AssistantLabelKey =
  | "Welcome"
  | "Suggestion 1"
  | "Suggestion 2"
  | "Suggestions Title"
  | "Deterministic"
  | "Deterministic Preferred"
  | "Generative"
  | "Analyst"
  | "Advisor"
  | "Partner";

export const ASSISTANT_LABEL: Record<AssistantLabelKey, AssistantLabelKey> = {
  Welcome: "Welcome",

  "Suggestions Title": "Suggestions Title",
  "Suggestion 1": "Suggestion 1",
  "Suggestion 2": "Suggestion 2",

  Deterministic: "Deterministic",
  "Deterministic Preferred": "Deterministic Preferred",
  Generative: "Generative",

  Analyst: "Analyst",
  Advisor: "Advisor",
  Partner: "Partner",
};

export const DEFAULT_ASSISTANT_LABELS = [
  { group: "Welcome", label: ASSISTANT_LABEL.Welcome, value: "How can I help you today?" },

  { group: "Suggestions", label: ASSISTANT_LABEL["Suggestion 1"], value: "How are the markets doing?" },
  { group: "Suggestions", label: ASSISTANT_LABEL["Suggestion 2"], value: "Give me a profile of Nvidia" },
  { group: "Suggestions", label: ASSISTANT_LABEL["Suggestions Title"], value: "Related topics" },

  { group: "Mode", label: ASSISTANT_LABEL.Deterministic, value: "Deterministic" },
  {
    group: "Mode",
    label: ASSISTANT_LABEL["Deterministic Preferred"],
    value: "Preferably deterministic with generative complements",
  },
  { group: "Mode", label: ASSISTANT_LABEL.Generative, value: "Generative" },

  { group: "Tone", label: ASSISTANT_LABEL.Analyst, value: "Analyst" },
  { group: "Tone", label: ASSISTANT_LABEL.Advisor, value: "Advisor" },
  { group: "Tone", label: ASSISTANT_LABEL.Partner, value: "Partner" },
];
